import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ModuleService {
  // legacy code expects `moduleService.id` numeric value
  public id: number = Number(environment.moduleId || 0);
}
